module.exports = __webpack_public_path__ + "8f0a799715aec4d803feaf999acead68.jpg";